import { render } from "./popup-draggable.vue?vue&type=template&id=6132d032"
import script from "./popup-draggable.vue?vue&type=script&lang=js"
export * from "./popup-draggable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__